export enum eSideOrientationBabylonMap {
    frontSide = 0,
    backSide = 1,
    doubleSide = 2,
}
export enum eUvMapAxisBabylonMap {
    x = 0,
    y = 1,
    z = 2,
}
export enum eUvModeBabylonMap {
    planar = 0,
    box = 1,
    cylindrical = 2,
    spherical = 3,
}
export enum eAlphaModeBabylonMap {
    disable = 0,
    add = 1,
    combine = 2,
    subtract = 3,
    multiply = 4,
}
